import { Type } from "@sinclair/typebox";
export const DeepLinkRegionSchema = Type.Union([
    Type.Literal("sg"),
    Type.Literal("hk"),
]);
export const DeepLinkPathValues = [
    "partner",
    "extend",
    "add-item",
    "view-item",
    "view-policy",
    "view-invoice",
    "view-claim",
    "singpass",
];
export const DeepLinkPathSchema = Type.Union([
    Type.Literal("partner"),
    Type.Literal("extend"),
    Type.Literal("add-item"),
    Type.Literal("view-item"),
    Type.Literal("view-policy"),
    Type.Literal("view-invoice"),
    Type.Literal("view-claim"),
    Type.Literal("singpass"),
]);
export const DeepLinkPayloadSchema = Type.Object({
    path: DeepLinkPathSchema,
    params: Type.Record(Type.String(), Type.String()),
    region: DeepLinkRegionSchema,
});
export const DeepLinkFingerprintSchema = Type.Object({
    ip: Type.String(),
    userAgent: Type.String(),
    screenWidth: Type.Number(),
    screenHeight: Type.Number(),
});
export const ClientFingerprintSchema = Type.Object({
    userAgent: Type.String(),
    screenWidth: Type.Number(),
    screenHeight: Type.Number(),
});
export const DeepLinkUtmSchema = Type.Object({
    source: Type.Optional(Type.String()),
    medium: Type.Optional(Type.String()),
    campaign: Type.Optional(Type.String()),
    content: Type.Optional(Type.String()),
    anid: Type.Optional(Type.String()),
});
export const DeepLinkTokenSchema = Type.Object({
    _id: Type.String(),
    token: Type.String(),
    payload: DeepLinkPayloadSchema,
    fingerprint: Type.Optional(DeepLinkFingerprintSchema),
    utm: Type.Optional(DeepLinkUtmSchema),
    clicks: Type.Number(),
    conversions: Type.Number(),
    createdAt: Type.String({ format: "date-time" }),
    resolvedAt: Type.Optional(Type.String({ format: "date-time" })),
    expiresAt: Type.Union([Type.String({ format: "date-time" }), Type.Null()]),
    createdBy: Type.Optional(Type.String()),
});
